"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateMeetingWorkspaceServiceActionSchema () {
        return CreateMeetingWorkspaceServiceActionSchema;
    },
    get UpdateMeetingWorkspaceServiceActionSchema () {
        return UpdateMeetingWorkspaceServiceActionSchema;
    },
    get WorkspaceExtendedModel () {
        return WorkspaceExtendedModel;
    },
    get WorkspaceModel () {
        return WorkspaceModel;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("./base");
const WorkspaceModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    status: _models.MeetingWorkspaceStatusSchema,
    participants: _zod.z.array(_base.UserParticipantRecord),
    created: _base.UserActionRecord,
    updated: _base.UserActionRecord
});
const WorkspaceExtendedModel = WorkspaceModel.omit({
    created: true,
    participants: true
}).extend({
    created: _base.UserActionRecord.extend({
        name: _zod.z.string().optional()
    }),
    participants: _zod.z.array(_base.UserParticipantRecord.extend({
        name: _zod.z.string().optional()
    })),
    previousMeetingStartDateTime: _utilsisomorphic.transformDate.optional(),
    upcomingMeetingStartDateTime: _utilsisomorphic.transformDate.optional()
});
const CreateMeetingWorkspaceServiceActionSchema = _models.MeetingWorkspacesSchema.pick({
    name: true,
    participants: true
});
const UpdateMeetingWorkspaceServiceActionSchema = _models.MeetingWorkspacesSchema.pick({
    name: true,
    status: true,
    participants: true,
    updated: true
}).partial();
